import React from 'react';
import { useDsTranslateMessage } from '@mc/wink/internationalization/useDsTranslateMessage';
import stylesheet from './DataWellGroup.css';

export default function PositiveArrow() {
  const trendingPositiveText = useDsTranslateMessage({
    id: 'mcds.data_well.trending_positive',
    defaultMessage: 'Trending positive',
  });
  return (
    <div className={stylesheet.typeIcon}>
      <span className="wink-visually-hidden">{trendingPositiveText}</span>
      <svg
        width="10"
        height="8"
        viewBox="0 0 10 8"
        fill="#00892E"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5 4.37114e-07L10 8L0 8L5 4.37114e-07Z" />
      </svg>
    </div>
  );
}

export function NegativeArrow() {
  const trendingNegativeText = useDsTranslateMessage({
    id: 'mcds.data_well.trending_negative',
    defaultMessage: 'Trending negative',
  });
  return (
    <div className={stylesheet.typeIcon}>
      <span className="wink-visually-hidden">{trendingNegativeText}</span>
      <svg
        width="10"
        height="8"
        viewBox="0 0 10 8"
        fill="#DB334D"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5 8L0 0L10 1.74846e-06L5 8Z" />
      </svg>
    </div>
  );
}
